module.exports = function (inspirationService, $location) {
    return {
        restrict: 'E',
        link(scope) {
            inspirationService.getNavigationItems().then(function (response) {
                // Return the left panel Navigation Items and if not small format, open the first on the list
                scope.menuItems = response;
            });

            function isOpen(urlPart) {
                const sourcePath = $location.path().split('/');
                const urlPath = sourcePath[sourcePath.length - 1];
                return (urlPath === urlPart);
            }

            // Returns a css class that shows which page is currently active
            // If urlPart is last in the sourcePath, show gray banner styling (only-active)
            // If urlPart is anywhere else in string, show is-active (shows children)
            scope.isActive = function (urlPart) {
                const sourcePath = $location.path().split('/');
                if (isOpen(urlPart)) {
                    return 'is-only-active';
                } else if (sourcePath.indexOf(urlPart) > -1) {
                    return 'is-active';
                }
                return '';
            };
        },
        template: require('./inspiration-navigation-template-v2.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/inspiration/inspiration-navigation-directive-v2.js
 **/